module.exports = __webpack_public_path__ + "img/messange.b2e10bf8.svg";